<template>
    <div v-separator-link="200">
        <div class="gcmcn-form-title">{{ event ? 'Edit' : 'Add'}} event</div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item class="gcmcn-form-input" prop="name">
                    <div class="gcmcn-form-label">Name</div>
                    <el-input
                        size="mini"
                        v-model="form.name"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    class="gcmcn-form-input"
                    prop="event_uid"
                >
                    <div class="gcmcn-form-label">Universe</div>
                    <el-select
                        v-model="form.universe_uid"
                        popper-class="gcmcn-popper"
                        size="mini"
                        placeholder="Select a universe"
                    >
                        <el-option
                            v-for="universe in universesFiltered"
                            :key="universe.uid"
                            :label="universe.display_name"
                            :value="universe.uid"
                        ></el-option>
                    </el-select>
                    <div
                        v-if="event && $store.getters.entities.length > 1"
                        class="form-info"
                    >
                        Only universes related to the same entity are displayed.
                    </div>
                </el-form-item>

                <el-form-item class="gcmcn-form-input">
                    <div class="gcmcn-form-label">Max latency (zixi)</div>
                    <el-select
                        v-model="form.max_latency_ms"
                        size="mini"
                        popper-class="gcmcn-popper"
                    >
                        <el-option v-for="lat in $store.getters.sortedLatencies"
                            :key="lat.uid"
                            :label="`${lat.value_ms} ms (${lat.name})`"
                            :value="lat.value_ms"
                        >
                        </el-option>
                        <el-option label="/" :value="0"></el-option">
                    </el-select>
                </el-form-item>

                <el-form-item class="gcmcn-form-input">
                    <div class="gcmcn-form-label">Min latency (srt)</div>
                    <el-select
                        v-model="form.min_latency_ms"
                        size="mini"
                        popper-class="gcmcn-popper"
                    >
                        <el-option v-for="lat in $store.getters.sortedLatencies"
                            :key="lat.uid"
                            :label="`${lat.value_ms} ms (${lat.name})`"
                            :value="lat.value_ms"
                        >
                        </el-option>
                        <el-option label="/" :value="0"></el-option">
                    </el-select>
                </el-form-item>

                <el-form-item class="gcmcn-form-input" style="margin-bottom: 0;">
                    <div class="gcmcn-form-label">Default thumbnail</div>
                    <upload-file
                        style="margin-top: 10px;"
                        :default-image="defaultImage"
                        @image-uploaded="onCropImage"
                    ></upload-file>
                </el-form-item>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm">Save
                    </el-button>
                </div>
            </el-form>
        </div>
        <cropper-modal
            ref="cropper"
            @on-image-cropped="onImageCropped"
            title="Configure thumbnail"
        >
            <ul class="crop-rules">
                <li>Image formats allowed are jpeg, jpg and png.</li>
                <li>Best ratio 16:9</li>
                <li>Minimal image size allowed is 400 x 225.</li>
            </ul>
        </cropper-modal>
    </div>
</template>
<script>
import { UploadFile, CropperModal, } from 'gcmcn-common';
export default {

    components: {
        UploadFile,
        CropperModal,
    },

    props: {
        universes: {
            required: true,
            type: Array,
        },
        event: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
    },

    data (){
        return {
            loading: false,
            form: {
                name: '',
                default_thumbnail: null,
                universe_uid: '',
                max_latency_ms: 0,
                min_latency_ms: 0,
            },
            defaultImage: null,

            defaultEventThumbnail: '../../../../static/image/no_preview.png',
        };
    },

    computed: {
        rules () {
            return {
                name: [{ required: true, validator: this.authorizedCharacters }],
                universe_uid: [{ required: true }],
            };
        },

        selectedUniverse (){
            return this.universes.find((u) => u.uid === this.form.universe_uid);
        },

        eventRelatedUniverse (){
            return this.universes.find((u) => u.uid === this.event.universe_uid);
        },

        universesFiltered (){
            let universes = this.universes.slice();
            if(this.event){
                universes = universes.filter((u) => {
                    return u.scopes.entity_uid === this.eventRelatedUniverse.scopes.entity_uid;
                });
            }
            return universes;
        },

    },

    watch: {
        event: {
            handler (){
                this.setForm();
            },
            deep: true,
            immediate: true,
        }
    },

    created (){
    },

    methods: {
        setForm (){
            if(this.event){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.event)));
                if(this.form.default_thumbnail){
                    this.defaultImage = this.form.default_thumbnail;
                }
            }else{
                this.$set(this, 'form', {
                    name: '',
                    default_thumbnail: null,
                    universe_uid: '',
                    max_latency_ms: 0,
                    min_latency_ms: 0,
                });
            }
        },
        authorizedCharacters(rules, value, callback) {
            if(!this.form.name) {
                return callback(new Error('Name is required'));
            } else if (!this.form.name.match(this.$store.getters.authorizedCharactersRegex)) {
                return callback(new Error('Invalid name'));
            } else {
                callback();
            }
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let form = JSON.parse(JSON.stringify(this.form));
                    let action;
                    let postData = { item: form, model: 'events'};
                    let messageType = this.event ? 'update' : 'create';
                    let defaultThumbnail = this.form.default_thumbnail;
                    delete form.default_thumbnail;
                    if(this.event){
                        action = 'patchItem';
                        this.form.url = this.event.url;

                    }else{
                        action = 'createItem';
                        postData.url = this.$store.state.api.meta.listModels.events.url;
                        postData.scopes = {'X-Entity-Uid': this.selectedUniverse.scopes.entity_uid};
                    }
                    this.$store.dispatch(action, postData).then( async (res) => {
                        this.$message({
                            message: `Event ${messageType}d!`,
                            type: 'success'
                        });
                        if( defaultThumbnail === null){
                            defaultThumbnail = await this.$store.dispatch('createBlobFromUrl', {imageUrl: this.defaultEventThumbnail});
                        }
                        if(typeof(defaultThumbnail) !== 'string'){
                            let fd = new FormData();
                            fd.append('default_thumbnail', defaultThumbnail);
                            this.$store.dispatch('patchItemFormData', {
                                item: fd,
                                url: res.url,
                                model: 'events',
                            }).then(() => {
                                this.loading = false;
                                this.$emit('on-event-created');
                            }).catch((e) => {
                                this.loading = false;
                                console.error(e);
                            });
                        }else{
                            this.loading = false;
                            this.$emit('on-event-created');
                        }
                    }).catch((e) => {
                        this.loading = false;
                        console.error(e);
                        this.$message.error(`Error on event ${messageType === 'update' ? messageType : 'creation'}.`);
                    });
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
        onCropImage (data){
            this.$refs.cropper.open(data);
        },
        async onImageCropped (croppedImage){
            const url = croppedImage;
            const file = await this.$store.dispatch('createBlobFromUrl', {imageUrl: url, addBackgroundToImage: false});
            this.defaultImage = croppedImage;
            this.form.default_thumbnail = file;
        },
    },
};
</script>

<style lang="scss">
.crop-rules{
    text-transform: initial;
    color: #bbb;
}
.inputs-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .flex-basis-5{
        flex-basis: calc( 50% - 10px);
    }
    .flex-basis-10{
        flex-basis: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Events/event-form.vue